// Core modules
import { Component, OnInit } from '@angular/core';
import { AppRootService } from "app/shared/services/app-root/app-root-service";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { forkJoin } from "rxjs";
import { IaqoboAirPermission } from "app_locobook/shared/iaqobo-air-permission.enum";
import { PriceSwitcherService } from "libraries/component/tab-navigation/price-switcher.service";
import { EXRateType } from "libraries/interfaces/ITotal";

declare var wenji: any;
declare var document: any;

@Component({
    selector: 'locobook',
    templateUrl: './locobook.component.html'
})
export class LocobookComponent implements OnInit {

    constructor(
        private readonly appRootService: AppRootService,
        private readonly permissionResourceService: PermissionResourceService,
        private readonly priceSwitcherService: PriceSwitcherService,
    ) {
    }

    public ngOnInit(): void {
        //get yii params
        this.setAppName();

        forkJoin([
            this.permissionResourceService.hasPermission(IaqoboAirPermission.IQBA_BOOKING_PRICE_COST_SHOW),
            this.permissionResourceService.hasPermission(IaqoboAirPermission.IQBA_BOOKING_PRICE_RETAIL_SHOW),
        ])
            .subscribe(([canViewCost, canViewRetail]: [boolean, boolean]): void => {
                if (canViewCost && canViewRetail) {
                    this.appRootService.setAppConfig({
                        ...wenji.locobook,
                        code: 'locobook',
                        isShowPriceSwitcher: true,
                    });
                }
                if(!canViewCost && canViewRetail){
                    this.priceSwitcherService.selectPrice(EXRateType.retail);
                }
                if(canViewCost && !canViewRetail){
                    this.priceSwitcherService.selectPrice(EXRateType.cost);
                }
            });

    }

    public setAppName(): void {
        document.title = wenji.locobook.name;
        sessionStorage.setItem('childAppName', wenji.locobook.name);
    }

}
